export const TOP_UP_WALLET_START = 'TOP_UP_WALLET_START';
export const TOP_UP_WALLET_SUCCESS = 'TOP_UP_WALLET_SUCCESS';
export const TOP_UP_WALLET_ERROR = 'TOP_UP_WALLET_ERROR';
